import React from 'react'
import './ErrorDisplay.scss'

const ErrorDisplay = ({detail}) => {
  return (
    <div className="error-display">
      <h2>We had a problem.</h2>
      <code>{detail.message}</code>
    </div>
  )
}

export default ErrorDisplay
